var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1499 16H3.3999L12.6499 6.74995L11.4249 5.49995L2.1499 14.775V16ZM15.8499 5.64995L12.4749 2.29995L13.7999 0.999951C14.0832 0.716618 14.4376 0.574951 14.8629 0.574951C15.2876 0.574951 15.6416 0.716618 15.9249 0.999951L17.1499 2.22495C17.4332 2.52495 17.5832 2.87895 17.5999 3.28695C17.6166 3.69562 17.4749 4.04162 17.1749 4.32495L15.8499 5.64995ZM1.5499 17.5C1.2999 17.5 1.08757 17.4126 0.912902 17.238C0.737569 17.0626 0.649902 16.85 0.649902 16.6V14.5C0.649902 14.3833 0.670902 14.271 0.712902 14.163C0.754236 14.0543 0.824902 13.95 0.924902 13.85L11.3999 3.37495L14.7749 6.74995L4.2999 17.225C4.1999 17.325 4.0959 17.396 3.9879 17.438C3.87924 17.4793 3.76657 17.5 3.6499 17.5H1.5499ZM12.0249 6.12495L11.4249 5.49995L12.6499 6.74995L12.0249 6.12495Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.95f6817f.svg";
export { ForwardRef as ReactComponent };